"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Types_1 = require("../Types");
var Components_1 = require("../Components");
var RequestLookupFilters = /** @class */ (function (_super) {
    __extends(RequestLookupFilters, _super);
    function RequestLookupFilters(props) {
        var _this = _super.call(this, props) || this;
        _this.changeRequestLookupType = function (type) {
            var _a, _b, _c;
            _this.props.changeRequestLookupType(type);
            (_a = _this.packIdentiferButtonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            (_b = _this.uprcButtonRef.current) === null || _b === void 0 ? void 0 : _b.blur();
            (_c = _this.transactionIdButtonRef.current) === null || _c === void 0 ? void 0 : _c.blur();
        };
        _this.fetchResults = function (filters) {
            _this.props.fetchResults(filters);
        };
        _this.packIdentiferButtonRef = React.createRef();
        _this.uprcButtonRef = React.createRef();
        _this.transactionIdButtonRef = React.createRef();
        return _this;
    }
    RequestLookupFilters.prototype.render = function () {
        var _this = this;
        var filters = function () {
            switch (_this.props.selectedType) {
                case Types_1.RequestLookupType.PackIdentifer:
                    return React.createElement(Components_1.PackIdentifierFilter, { fetchResults: _this.fetchResults, resources: _this.props.resources });
                case Types_1.RequestLookupType.TransactionId:
                    return React.createElement(Components_1.TransactionIdFilter, { fetchResults: _this.fetchResults, resources: _this.props.resources });
                case Types_1.RequestLookupType.UPRC:
                    return React.createElement(Components_1.UprcFilter, { fetchResults: _this.fetchResults, resources: _this.props.resources });
                case Types_1.RequestLookupType.None:
                default:
                    return React.createElement("div", null, _this.props.resources.RequestLookup_PleaseChooseAnOption);
            }
        };
        return (React.createElement("div", { className: "mb-4" },
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, null),
                React.createElement(reactstrap_1.Col, { className: "mb-2", xs: "auto" },
                    React.createElement(reactstrap_1.ButtonGroup, { size: "lg" },
                        React.createElement(reactstrap_1.Button, { outline: true, color: "primary", innerRef: this.packIdentiferButtonRef, onClick: function () { return _this.changeRequestLookupType(1); }, active: this.props.selectedType === 1 }, this.props.resources.PackIdentifer),
                        React.createElement(reactstrap_1.Button, { outline: true, color: "primary", innerRef: this.uprcButtonRef, onClick: function () { return _this.changeRequestLookupType(2); }, active: this.props.selectedType === 2 }, this.props.resources.UPRC),
                        React.createElement(reactstrap_1.Button, { outline: true, color: "primary", innerRef: this.transactionIdButtonRef, onClick: function () { return _this.changeRequestLookupType(3); }, active: this.props.selectedType === 3 }, this.props.resources.TransactionId))),
                React.createElement(reactstrap_1.Col, null)),
            filters()));
    };
    return RequestLookupFilters;
}(React.Component));
exports.RequestLookupFilters = RequestLookupFilters;
//# sourceMappingURL=RequestLookupFilters.js.map